import React, { CSSProperties } from 'react';
import Typography, { TypographyVariant } from '../typography/typography';
import Icon, { IconType } from '../icons/icon';
import InfoIcon from '../info-icon/info-icon';

interface DataCardProps {
  body: string;
  iconVariant: IconType;
  title: string;
  style?: React.CSSProperties;
  infoTitle?: string;
  infoMessage?: string;
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  bodyClassName?: string;
  borderClassName?: string;
}

function DataCard({
  body,
  iconVariant,
  title,
  style,
  infoTitle,
  infoMessage,
  disabled,
  className,
  iconClassName = 'icon-negative-accent',
  titleClassName = 'text-input-primary',
  bodyClassName = 'text-input-primary',
  borderClassName = 'border-light',
}: DataCardProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        ...style,
      }}
      className={`${borderClassName} ${className || ''}`}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0.25rem',
          }}
        >
          <Icon
            iconType={iconVariant}
            className={disabled ? 'text-secondary' : iconClassName}
          />

          <Typography
            variant={TypographyVariant.Subtitle1}
            style={{ paddingLeft: '0.5rem' }}
            className={disabled ? 'text-secondary' : titleClassName}
          >
            {title}
          </Typography>
        </div>
        {infoMessage && (
          <InfoIcon disabled={disabled} title={infoTitle} body={infoMessage} />
        )}
      </div>
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          paddingTop: '0.75rem',
          paddingBottom: '0.75rem',
        }}
      >
        <Typography
          variant={TypographyVariant.H6}
          className={disabled ? 'text-secondary' : bodyClassName}
        >
          {body}
        </Typography>
      </div>
    </div>
  );
}

export default DataCard;
